import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Box, Modal, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { apiAction, generalSet } from '../../store/generalSlice';

const RuleGroups = () => {
  const dispatch = useDispatch();
  const { ruleGroups } = useSelector((state) => state.general);
  const [selectedRuleGroup, setSelectedRuleGroup] = useState(null);

  const [open, setOpen] = useState(false);

  const handleOpen = (ruleGroup) => {
    setSelectedRuleGroup(ruleGroup);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRuleGroup(null);
  };

  const handleDelete = () => {
    dispatch(
      generalSet({
        reduxField: 'ruleGroups',
        value: ruleGroups.filter((ruleGroup) => ruleGroup._id !== selectedRuleGroup._id),
      })
    );
    dispatch(
      apiAction({
        reduxField: 'deletedRuleGroup',
        route: `ruleGroups/deleteRuleGroupById`,
        ruleGroupId: selectedRuleGroup._id,
      })
    );
    handleClose();
  };

  useEffect(() => {
    dispatch(apiAction({ reduxField: 'ruleGroups', route: 'ruleGroups/getRuleGroups' }));
  }, [dispatch]);

  console.log({ ruleGroups });

  const columns = [
    {
      field: '_id',
      headerName: 'ID',
      width: 225,
    },
    {
      field: 'name',
      headerName: 'Name',
      width: 300,
      renderCell: (params) => <Link to={`/ruleGroup/${params.row._id}`}>{params.value}</Link>,
    },
    {
      field: 'rules',
      headerName: 'Rules',
      width: 100,
      renderCell: (params) => <>{params.row.ruleIds?.length || 0}</>,
    },
    {
      field: 'blockRuns',
      headerName: 'Block Runs',
      width: 200,
      renderCell: (params) => <>{params.row.blockRuns ? 'Enabled' : 'Disabled'}</>,
    },
    {
      field: 'details',
      headerName: 'Details',
      width: 200,
      renderCell: (params) => (
        <>
          <button className='btn btn-outline-danger' onClick={() => handleOpen(params.row)}>
            <i className='fa fa-trash' aria-hidden='true'></i>
          </button>
        </>
      ),
    },
  ];
  return Array.isArray(ruleGroups) ? (
    <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center'>
        <div className='col-lg-12 d-flex justify-content-center border-bottom' data-aos='fade-up' data-aos-delay='200'>
          <h1>Rule Groups</h1>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <Link to='/CreateRuleGroup' className='btn btn-outline-dark'>
          Create a Rule Group
        </Link>
      </div>
      <div className='row d-flex justify-content-center pt-lg-0 mt-2'>
        <Box style={{ height: 600, width: '100%' }}>
          <DataGrid
            rows={ruleGroups.map((ruleGroup) => {
              return { id: ruleGroup._id, ...ruleGroup };
            })}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            //   checkboxSelection

            disableSelectionOnClick
          />
        </Box>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <div
          className='modal-content'
          style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', outline: 'none', margin: '25%' }}
        >
          <h4>Confirm Deletion</h4>
          <p>Are you sure you want to delete this rule group?</p>
          <Button variant='contained' color='secondary' onClick={handleDelete}>
            Delete
          </Button>
          <Button variant='contained' onClick={handleClose}>
            Cancel
          </Button>
        </div>
      </Modal>
    </div>
  ) : null;
};

export default RuleGroups;
